/**
 * App mark: a charcoal tile with three fanned cards (the hero's yellow ·
 * mint · blue accent) and a white front card carrying a "split" sign.
 * Same artwork as public/favicon.svg.
 */
export function Logo({ size = 72, className }: { size?: number; className?: string }) {
  return (
    <svg className={className} width={size} height={size} viewBox="0 0 64 64" aria-hidden>
      <defs>
        <radialGradient id="logo-bg" cx="0" cy="0" r="1.2">
          <stop offset="0" stopColor="#3a3f45" />
          <stop offset="0.55" stopColor="#1b1d21" />
          <stop offset="1" stopColor="#111214" />
        </radialGradient>
      </defs>
      <rect width="64" height="64" rx="16" fill="url(#logo-bg)" />
      <rect x="15" y="15" width="24" height="32" rx="6" fill="#f5d547" transform="rotate(-16 27 31)" />
      <rect x="19" y="15" width="24" height="32" rx="6" fill="#6ed3a6" transform="rotate(-6 31 31)" />
      <rect x="23" y="16" width="24" height="32" rx="6" fill="#58a6f2" transform="rotate(4 35 32)" />
      <rect x="25" y="18" width="24" height="32" rx="6" fill="#ffffff" transform="rotate(10 37 34)" />
      <g transform="rotate(10 37 34)" fill="#111214">
        <rect x="30" y="32.6" width="14" height="2.8" rx="1.4" />
        <circle cx="37" cy="27.5" r="2" />
        <circle cx="37" cy="40.5" r="2" />
      </g>
    </svg>
  );
}
